/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import * as API from "../API/api";
import { MyToggleButton } from "./helpercomponents/CustomGridCells/MyToggleButton"
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from "../forms/helpercomponents/CustomGridCells/DateCell";
import { LookupCell } from "../forms/helpercomponents/CustomGridCells/LookupCell";
import { ImageCell } from "./helpercomponents/CustomGridCells/ImageCell";
import EditForm from "./helpercomponents/editForm";
import { COLUMNSTYPE, ENTITYNAME, LOCALSTORAGE_KEY, MODULE, FILEURL, SOCKET_EVENTS, SOCKET_ACTION, LOGEVENT, ROLETYPE, TOAST_TYPES, PAGE_SIZES, PREFERENCE_ENTITYNAME } from "../constant/constant";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuCommandCell } from "./helpercomponents/CustomGridCells/MenuCommandCell ";
import { TimeCell } from "./helpercomponents/CustomGridCells/TimeCell";
import { collectionMenuModel } from "./helpercomponents/contextMenu/menus/collectionMenuModel";
import { UserPreference } from "../../modules/userPreference/UserPreference";
import { utility } from "../utility/utilityProvider";
import { ArrayCell } from "./helpercomponents/CustomGridCells/ArrayCell";
import { CheckboxCell } from "./helpercomponents/CustomGridCells/CheckBoxCell";
import { HrefCell, HyperLinkCell } from "./helpercomponents/CustomGridCells/HrefCell";
import { useTranslation } from "../../locale/useTranslation";
import BackRoundButton from "./helpercomponents/buttons/BackRoundButton";
import AddRoundButton from "./helpercomponents/buttons/AddRoundButton";
import RefreshButton from "./helpercomponents/buttons/RefreshButton";
import PreferenceRoundButton from "./helpercomponents/buttons/PreferenceRoundButton";
import { EnumCell, SIDEnumCell } from "./helpercomponents/CustomGridCells/EnumCell";
import RoundButton from "./helpercomponents/buttons/RoundButton";
import { PlatformCell, arrayEnumCell, daysCell } from "./helpercomponents/CustomGridCells/PlatformCell";
import MyStatusCell from "../../components/MyStatusCell";
import { IconCell } from "./helpercomponents/CustomGridCells/IconCell";
import socket from "../socket/socket";
import { getter } from "@progress/kendo-data-query";
import ActionButton from "./helpercomponents/buttons/ActionButton";
import { Loader } from "./helpercomponents/Loader";
import { colorCell } from "./helpercomponents/CustomGridCells/ColorCell";
import BossDialog from "../../components/BossDialog";
import { MultiLangArrayCell } from "./helpercomponents/CustomGridCells/MultiLangArrayCell";
import { ContentArrayImageCell } from "./helpercomponents/CustomGridCells/ContentArrayImageCell";
import { TextWithIconCell } from "./helpercomponents/CustomGridCells/TextWithIconCell";
import castTypeCell from "./helpercomponents/CustomGridCells/CastTypeCell";
import { CustomCell } from "./helpercomponents/CustomGridCells/CustomCell";
import { TransmissionTypeStatusCell } from "../../components/TransmissionTypeStatusCell";
import { TransmissionBrowser } from "../../modules/MediaLibrary/NodeTreeView/TransmissionBrowser";
import CreateTransmissionForm from "../OTT/CreateTransmissionForm";
import MAMStatusCell from "../../components/MAMStatusCell";
import SegmentExtensionEditForm from "../../modules/Segment/SegmentExtensionEditForm";
import TransmissionReportForm from "../../modules/MediaLibrary/transmission/TransmissionReportForm";
import ToastNotification from "../../components/ToastNotification";
import CreateSeriesTransmissionForm from "../../modules/MediaLibrary/NodeTreeView/CreateSeriesTransmissionForm";

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

export const VersionBrowserCollection = (props) => {

    const getInitialPageSize = () => {
        const stored = utility.getValue(LOCALSTORAGE_KEY.versionBrowser_pageSize);
        const parsed = parseInt(stored);
        if (parsed && PAGE_SIZES.includes(parsed)) {
            return parsed;
        }
        return props.page_take ?? 50;
    };

    const [pageSize, setPageSize] = useState(getInitialPageSize);
    let page_take = pageSize;
    let showAdd = props.showAdd ?? true;
    let showBack = props.showBack ?? true;
    let showArchive = props.showArchive ?? true;
    let showCommandCell = props.showCommandCell ?? true;
    let showEdit = props.showEdit ?? true;
    let showDelete = props.showDelete ?? true;
    let showTitle = props.showTitle ?? true;
    let gridRowRender = props.gridRowRender;
    let CustomEditForm = props.customEditForm ?? EditForm;
    let filterable = props.filterable ?? false;
    let sortable = props.sortable ?? true;
    let isPageable = props.isPageable ?? true;
    let wherestatement = props.wherestatement ?? [];
    let andWhereStatement = props.andWhereStatement ?? [];
    let sort = props.sort ?? { _id: 1 };
    let customColumns = props.customColumns ?? [];
    let openNewEditForm = props.openNewEditForm ?? false;
    let myTitle = props.title ?? "";
    let myMenuModel = props.menuModel ?? collectionMenuModel;
    let entityName = props.entityname;
    let showPreferenceButton = props.showPreferenceButton ?? true;
    let hideArchiveProps = props.hideArchive ?? false;
    let enableMutliSelect = props.enableMutliSelect ?? false;
    let module = props?.module;
    let showLogs = props.showLogs ?? true;
    let doLoad = props.isLoading ?? true;
    let isTieredMenu = props.isTieredMenu ?? false;

    const navigate = useNavigate();
    const loc = useLocation();
    const lang = useTranslation();

    const [gridData, setGridData] = useState([]);
    const [total, setTotal] = useState(1);
    const [openForm, setOpenForm] = useState(false);
    const [editItem, setEditItem] = useState({ SID: 1 });
    const [warningDialog, setWarningDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isNoRecords, setIsNoRecords] = useState(false);
    const [showPreferences, setShowPreferences] = useState(false);
    const [dataColumns, setDataColumns] = useState([]);
    const [searchText, setSearchText] = useState(null);
    const [showArchived, setShowArchived] = useState(false);
    const [hideArchive] = useState(hideArchiveProps);
    const [selectedState, setSelectedState] = useState({});
    const initialSort = { field: Object.keys(sort)[0], dir: sort[Object.keys(sort)[0]] == 1 ? "asc" : "desc" }
    const [gridSort, setGridSort] = useState([initialSort]);
    const [showCreateTransmission, setShowCreateTransmission] = useState(false);
    const [showTransmissionBrowser, setShowTransmissionBrowser] = useState(false);
    const [showSegmentExtensionPopup, setShowSegmentExtensionPopup] = useState(false);
    const [transmissionReport, setTransmissionReport] = useState({ show: false, message: '', items: [] });
    const [showCreateSeriesTransmission, setShowCreateSeriesTransmission] = useState(false);

    const preferenceColumnENntityName = PREFERENCE_ENTITYNAME.versionBrowser;

    const selectedItemsRef = useRef([]);
    const gridRef = useRef(null);

    const setSelectedItem = (items) => { selectedItemsRef.current = items; };

    const urlParams = new URLSearchParams(location?.search ?? "");
    const companyId = urlParams?.get('companyId');
    const paramQuery = { curPage: parseInt(urlParams.get('page')) || 1, index: parseInt(urlParams.get('index')) || 0 }
    const [page, setPage] = useState({ skip: (paramQuery.curPage - 1) * pageSize, take: pageSize });

    if (entityName == ENTITYNAME.Users && companyId) { wherestatement = [...wherestatement, ['Company._id', '=', companyId]]; }

    useEffect(() => {
        let searchtext = urlParams?.get('searchtext');
        if (searchtext) {
            setSearchText(searchtext);
        }
    }, [location?.search]);

    let href = loc.state ? loc.state.href : false;
    if (href) {
        wherestatement = loc.state.wherestatement;
    }

    useEffect(() => {
        setShowArchived(false);
        doLoad ? setIsLoading(true) : setIsLoading(false);
        setPage({ skip: (paramQuery.curPage - 1) * pageSize, take: pageSize });
        loaddata({ per_page: pageSize, current_page: paramQuery.curPage }, wherestatement, andWhereStatement, urlParams?.get('searchtext') || '', false);
    }, [props.entityname, props.gridData, props.title, props.wherestatement]);

    const onSearch = (e) => {
        e.preventDefault();
        let text = e.target.value?.trim();
        setSearchText(text);
    };

    // Search 
    useEffect(() => {
        if (searchText == null) return;
        let sortEvent = gridSort[0] ?? initialSort;
        if (searchText != "") {
            const timeOut = setTimeout(() => {
                setIsLoading(true);
                loaddata({ per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
            }, 700);
            return () => clearTimeout(timeOut);
        } else {
            setIsLoading(true);
            setPage({ skip: (paramQuery.curPage - 1) * pageSize, take: pageSize });
            loaddata({ per_page: pageSize, current_page: paramQuery.curPage, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
        }
    }, [searchText]);

    useEffect(() => {
        if (gridRef.current && paramQuery.index >= 0) {
            let updateIndex = paramQuery.index > pageSize ? paramQuery.index - ((paramQuery.curPage - 1) * pageSize) : paramQuery.index;
            const gridElement = gridRef.current.element || gridRef.current.wrapper || gridRef.current;
            const contentArea = gridElement.querySelector('.k-grid-content');
            if (!contentArea) return;
            const rows = contentArea.querySelectorAll('tr');
            if (updateIndex < rows.length) {
                const targetRow = rows[updateIndex];
                const rowOffsetTop = targetRow.offsetTop;
                const contentAreaHeight = contentArea.clientHeight;
                const scrollPosition = rowOffsetTop - contentAreaHeight / 2 + targetRow.clientHeight / 2;
                contentArea.scrollTo({
                    top: scrollPosition,
                    behavior: 'smooth',
                });
            }
        }
    }, [paramQuery.index, gridData]);

    const onKillUserSession = (userData) => {
        delete userData["Module"];
        console.log(userData);
        socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.KILL_USER_SESSION, module: MODULE.ALL, data: userData })
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `${userData.name} session has been killed successfully` });
    }

    const enterEdit = (item = {}) => {
        console.log("onEnterEdit");

        const safeItem = item ?? {};
        const sid = safeItem?.SID ?? 0;

        if (openNewEditForm === false) {
            setOpenForm(true);
            setEditItem(safeItem);
        } else {
            let current_page = page.skip / page.take + 1;
            let prevPath = safeItem?.prevPath ?? 0;

            let state = {
                copy: safeItem?.copy ? true : false,
                quickEdit: safeItem?.quickEdit ? true : false,
                prevPath: loc.pathname + `?page=${current_page + prevPath}`,
                paths: [loc.pathname],
                pagination: `?page=${current_page + prevPath}`
            };

            navigate(`${sid}?page=${current_page + prevPath}`, { state });
        }
    };

    const handleNavigate = (item) => {
        if (item?.Module) {
            window.open(item.path, "MyTargetWindowName");
        } else {
            navigate(`${item.path}`, { state: item });
        }
    }

    //onSubmit from EDIRFORM
    const handleSubmit = async (dataItem, dataToSave) => {
        console.log("handleSUbmit");
        //if datatosave is null then dataitem is datasave
        dataToSave = dataToSave == null ? dataItem : dataToSave;

        let isDuplicate = await utility.checkDuplicate(props.entityname, dataToSave);

        if (!isDuplicate) {
            setOpenForm(true);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.entry_already_exist_try_with_different_values_collection_error_message });
            return;
        }

        let res = await API.saveData(props.entityname, dataToSave);
        console.log(res);
        if (dataItem?.IsDefault) {
            await API.setAsDefault(entityName, dataItem?._id)
        }
        if (res.success) {
            if (showLogs) {
                let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: module, data: res.data, message: res.message };
                API.SaveLogs(logData);
            }
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            return;
        }
        socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
        utility.deleteLocalStorageItem(props.entityname)
        //to load grid with new data
        loaddata({ per_page: page_take, current_page: 1 }, wherestatement, andWhereStatement, searchText, showArchived);
        setOpenForm(false);
    };

    const handleCancelEdit = () => {
        setOpenForm(false);
    };

    const handleDelete = async (dataItem) => {
        console.log(dataItem);
        onConfirmDelete(dataItem)
    };

    const handleArchive = async (dataItem) => {
        console.log("Here");
        if (entityName == ENTITYNAME.Series || entityName == ENTITYNAME.Season) {
            var resArchiveUpdated = await API.onChangeArchiveInSeriesSeason({
                _id: dataItem._id,
                archive: !dataItem.Archive,
                entityName: entityName
            })
        } else {
            var resArchiveUpdated = await API.saveData(entityName, {
                ...dataItem,
                Archive: !dataItem.Archive
            })
        }

        if (resArchiveUpdated.success) {
            console.log(`Archive is been updated to ${!dataItem.Archive}`);
            if (module) {
                let logData = { event: !dataItem.Archive ? LOGEVENT.ARCHIVE : LOGEVENT.UNARCHIVE, module: module, data: { ...dataItem, Archive: !dataItem.Archive }, message: resArchiveUpdated.message };
                API.SaveLogs(logData);
            }
            let sortEvent = gridSort[0] ?? initialSort;
            let current_page = page.skip / page.take + 1;
            loaddata({ per_page: page_take, current_page: !dataItem.Archive ? current_page : 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
            socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
            utility.deleteLocalStorageItem(entityName);
        } else {
            console.log(resArchiveUpdated.message);
        }
    }

    const onCloseUserPrefence = () => {
        let sortEvent = gridSort[0] ?? initialSort;
        loaddata({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
        setShowPreferences(!showPreferences);

    }

    const setAsDefault = async (data) => {

        var setAsDefaultRes = await API.setAsDefault(entityName, data._id);
        if (setAsDefaultRes.success) {
            let sortEvent = gridSort[0] ?? initialSort;
            loaddata({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
            socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
            utility.deleteLocalStorageItem(entityName);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: setAsDefaultRes.message });
        }

    }

    const MyCheckBoxCell = (props) => {
        const value = props?.dataItem?.[props.field];
        return (
            <td style={{ marginLeft: "10px" }}>
                {value === 1 ? 'Yes' : 'No'}
            </td>
        );
    };

    const onShowTransmission = (data) => {
        if (data) { selectedItemsRef.current = [data]; }
        setShowTransmissionBrowser(true);
    };

    const onCreateTransmission = (data) => {
        if (data) { selectedItemsRef.current = [data]; }
        setShowCreateTransmission(true);
    };

    const onShowMedia = (data) => {
        if (!data || !data.MediaEpisode) return;
        const selectedMedia = data.MediaEpisode ?? {};
        window.open(`/home/MediaEpisode/${selectedMedia.MediaCategory?.Description}/${data.MediaEpisodeSID}`, "_blank");
    };

    const addSegmentExtension = (data) => {
        selectedItemsRef.current = [data];
        setShowSegmentExtensionPopup(true);
    };

    const onCreateSeriesTransmission = (data) => {
        if (data) { selectedItemsRef.current = [data]; }
        setShowCreateSeriesTransmission(true);
    }
    //Edit Row
    const MyCommandCell = (props) => (

        <MenuCommandCell
            {...props}
            showLogs={showLogs}
            enterEdit={enterEdit}
            cancelEdit={handleCancelEdit}
            onSubmit={handleSubmit}
            item={editItem}
            dataColumns={dataColumns}
            onDelete={handleDelete}
            onArchive={handleArchive}
            showEdit={showEdit}
            showDelete={showDelete}
            toNavigate={handleNavigate}
            myMenuModel={myMenuModel}
            module={module}
            openNewEditForm={openNewEditForm}
            onKillUserSession={onKillUserSession}
            setAsDefault={setAsDefault}
            isTieredMenu={isTieredMenu}
            onShowTransmission={onShowTransmission}
            onCreateTransmission={onCreateTransmission}
            onCreateSeriesTransmission={onCreateSeriesTransmission}
            onShowMedia={onShowMedia}
            addSegmentExtension={addSegmentExtension}
        />
    );

    const MyCustomToggleButton = (props) => (
        <MyToggleButton
            {...props}
            entityName={entityName}
            size={"small"}
            onGridDataUpdate={updateGridDataByIndex}
        />
    );

    const updateGridDataByIndex = (index, field, value) => {
        const updated = [...gridData];
        if (updated[index]) {
            updated[index] = { ...updated[index], [field]: value };
            setGridData(updated);
        }
    };

    const MyDatalookupCell = (props) => (
        <LookupCell {...props} dataColumns={dataColumns} />
    );

    const Mystatuscell = (props) => {
        const { dataItem } = props;

        let title = utility.getNestedValue(dataItem, props.field)?.toString();
        let tileBackColor = "#2a9d8f";

        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} />
        );
    };

    const MyMultiLangArrayCell = (props) => (
        <MultiLangArrayCell selectedLang={selectedLanguageRef.current} {...props} />
    )

    const loaddata = async (pagination, wherestatement, andWhereStatement, searchText, archive) => {

        if (props.gridColumns) {
            setDataColumns(props.gridColumns);
            setGridData(props.gridData);
            setIsLoading(false);
        } else {
            try {
                let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
                let columns = await API.getFormData(preferenceColumnENntityName, currentUserId);
                let finalSort = pagination.direction ? { [pagination.orderby ?? '_id']: pagination.direction == 'asc' ? 1 : -1 } : sort;
                let payload = {
                    page: pagination.current_page,
                    perPage: pagination.per_page,
                    sort: finalSort,
                    archive: archive,
                    query: wherestatement,
                    searchText,
                    columns
                }
                let json = await API.getVersionBrowser(payload);
                console.log(json?.data)
                setGridData(json?.data ?? []);
                setTotal(json?.pagination?.total);
                //if custmoe colum is coming from compemnent level then no need  a column from Server API
                customColumns.length > 0
                    ? setDataColumns(customColumns)
                    : setDataColumns(columns);

                // console.log(columns)
                setIsLoading(false);
            } catch (error) {
                console.log("error", error);
                setIsLoading(false);
                setIsNoRecords(true);
            }
        }
    };

    const errorHandler = (message) => {
        setWarningDialog(!warningDialog);
        setDeleteError(true);
        setDeleteErrorMessage(message);
    }

    const onConfirmDelete = async (dataItem) => {
        let res = { success: false, message: "" };
        switch (entityName) {
            case ENTITYNAME.DAI_CHANNELS:
                let user = utility.getValue(LOCALSTORAGE_KEY.userData);
                if (user?.RoleType?.ID == ROLETYPE.User) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.dai_channel_delete_error_messgae });
                    return;
                }
                res = await API.daiChannelDelete(dataItem._id);
                break;
            default:
                await API.deleteData(props.entityname, dataItem.SID);
        }
        if (!res.success) {
            errorHandler(res.message);
            return;
        }
        let current_page = page.skip / page.take + 1;
        let sortEvent = gridSort[0] ?? initialSort;
        loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, '', showArchived);
        socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
        utility.deleteLocalStorageItem(props.entityname);
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
    }

    const pageChange = async (e) => {
        if (e.page.take !== page.take) {
            setPageSize(e.page.take);
            utility.setValue(LOCALSTORAGE_KEY.versionBrowser_pageSize, e.page.take);
        }
        let current_page = e.page.skip / e.page.take + 1;
        let sortEvent = gridSort[0] ?? initialSort;
        setIsLoading(true);
        await loaddata({ per_page: e.page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
        setPage(e.page);
        cancelSelectedItem();
    };

    const onArchiveClick = () => {
        setShowArchived(!showArchived);
        let sortEvent = gridSort[0] ?? initialSort;
        if (!showArchived) {
            loaddata({ per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, true);
        } else {
            let current_page = page.skip / page.take + 1;
            loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, false);
        }
        cancelSelectedItem();
    }

    const refreshCollection = () => {
        setIsLoading(true);
        let current_page = page.skip / page.take + 1;
        let sortEvent = gridSort[0] ?? initialSort;
        loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
    }

    const onSortChange = (e) => {
        setGridSort(e.sort)
        let sortEvent = e.sort[0] ?? sort;
        let current_page = page.skip / page.take + 1;
        loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
    }

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);

        let selectedIds = Object.keys(newSelectedState);
        let tempSelected = [];

        selectedIds.map((value) => {
            if (newSelectedState[value]) {
                let filter = gridData.find((obj) => obj._id == value);
                tempSelected.push(filter);
            }
        });

        setSelectedItem(tempSelected);
    };


    const onHeaderSelectionChange = (event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);

        var selectedIds = Object.keys(newSelectedState);
        var tempSelected = [];

        if (checked) {
            selectedIds.map((value) => {
                if (newSelectedState[value]) {
                    var filtered = gridData.find((obj) => obj._id == value);
                    tempSelected.push(filtered);
                }
            });
        }
        setSelectedItem(tempSelected);
    };

    const onArchiveButtonClick = async () => {
        if (selectedItemsRef.current.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
            return;
        }
        for (let i = 0; i < selectedItemsRef.current.length; i++) {
            const item = selectedItemsRef.current[i];
            await handleArchive(item);
        }
        cancelSelectedItem();
    }

    const onEnterEdit = () => {
        enterEdit({ SID: 0 });
        cancelSelectedItem();
    }
    const cancelSelectedItem = () => {
        setSelectedItem([]);
        setSelectedState({});
    }

    let timeOut;
    const handleColumnResize = (event) => {
        let lockedCol = event.columns.filter((item) => item?.locked).length ?? 1;
        try {
            if (event.index == 0) return;
            if (dataColumns == undefined || dataColumns.length == 0 || dataColumns.length < event.index) return;
            let column = dataColumns[event.index - lockedCol];
            let payload = {
                entityName: column?.entityName,
                name: column?.name,
                width: event.newWidth
            };
            clearTimeout(timeOut);
            timeOut = setTimeout(() => {
                API.updateUserPreferenceColumnWidth(payload);
            }, 700);
        } catch (error) {
            console.error("Error handling column resize:", error);
        }
    };

    const onSaveCreateTransmission = async (dataList = {}) => {

        if (selectedItemsRef.current.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
            return;
        }

        let payload = {
            mediaSegments: selectedItemsRef.current,
            catalogue: {
                Catalogue: {
                    _id: dataList.Catalogue._id,
                    Description: dataList.Catalogue?.Description
                },
                ParentNodes: dataList.ParentNodes,
                Nodes: dataList.Nodes,
                Ott_Platforms: dataList.Ott_Platforms,
                TransmissionType: dataList.TransmissionType,
                AutoCreateNode: dataList?.AutoCreateNode
            },
            entityName: entityName
        };

        try {
            await onPublishTransmission(payload);
            // refreshCollection();

        } catch (err) {
            console.error(err);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Error creating transmission" });
        }
    };

    const onPublishTransmission = async (transmissionData = []) => {

        let transmissionRes = await API.createTransmissionFromVersion(transmissionData);
        if (transmissionRes.success) {
            let data = transmissionRes.data || {};
            let cratedTransmission = data.cratedTransmission || [];
            let notCreatedTransmissionsArr = data.notCreatedTransmissions || [];

            if (cratedTransmission.length > 0) {
                let updatedGridData = [...gridData];
                cratedTransmission.forEach(ct => {
                    let index = updatedGridData.findIndex(item => item._id === ct.mediaSegmentId);
                    if (index !== -1) {
                        updatedGridData[index] = { ...updatedGridData[index], totalTransmissions: ct.totalTransmission };
                    }
                });
                setGridData(updatedGridData);
            }

            utility.deleteLocalStorageItem(ENTITYNAME.Nodes);

            if (notCreatedTransmissionsArr.length > 0) {
                let reportItems = [
                    ...cratedTransmission.map(item => ({ Title: item.Title, node: item.node, message: 'Created successfully', status: 'success' })),
                    ...notCreatedTransmissionsArr.map(item => ({ Title: item.Title, node: item.node, message: item.message, status: 'failed' }))
                ];
                setTransmissionReport({
                    show: true,
                    message: transmissionRes.message || "Some transmissions were not created",
                    items: reportItems,
                    successCount: cratedTransmission.length,
                    failedCount: notCreatedTransmissionsArr.length
                });
            } else {
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: transmissionRes.message || "All transmissions created successfully" });
                cancelSelectedItem();
                setShowCreateTransmission(false);
            }
            // loaddata({ per_page: page_take, current_page: paramQuery.curPage }, wherestatement, andWhereStatement, '', false);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: transmissionRes.message });
        }

    }

    const onCloseSeriesTransmissionForm = () => {
        setShowCreateSeriesTransmission(false);
        const sortEvent = gridSort[0] ?? initialSort;
        loaddata({ per_page: page_take, current_page: paramQuery.curPage, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, false);
    }

    return (
        <>
            <div>
                {showTitle && (
                    <h1 className="page-title txt-color-bludeDark">
                        <i
                            className="fa fa-table marlr"
                            style={{ fontSize: "20px", color: "GrayText" }}
                        ></i>
                        <span>{myTitle === "" ? props.entityname : myTitle}</span>
                    </h1>
                )}
                <div className="flex-container">
                    <div className="martb mar">
                        {showBack && (
                            <BackRoundButton onClick={() => navigate(-1)}></BackRoundButton>
                        )}
                        {showAdd && (
                            <AddRoundButton onClick={onEnterEdit}></AddRoundButton>
                        )}
                        {showArchive && !enableMutliSelect && (
                            <ActionButton title={showArchived ? lang.un_archive_label : lang.archive} name={showArchived ? lang.un_archive_label : lang.archive}
                                onClick={onArchiveButtonClick} />
                        )}
                        {enableMutliSelect && selectedItemsRef.current.length !== 0 && (
                            <>
                                <RoundButton
                                    icon="tower-broadcast"
                                    btnColor="white"
                                    title="Create Transmission"
                                    onClick={() => setShowCreateTransmission(true)}
                                />
                            </>
                        )}
                    </div>
                    <div className="flex-container-reverse flex-item-auto">
                        <div className="input-group input-group w-300 martb" >
                            <input
                                type="text"
                                className="form-control shadow-inset-2 pt-0 pb-0"
                                id="searchInput"
                                placeholder={lang.search_button_text}
                                defaultValue={urlParams?.get('searchtext') || ""}
                                onChange={onSearch}
                                onFocus={(e) => {
                                    if (props.setOutSideFocus) {
                                        props.setOutSideFocus(true);
                                    }
                                }}
                                onBlur={(e) => {
                                    if (props.setOutSideFocus) {
                                        props.setOutSideFocus(false);
                                    }
                                }}
                            />
                            <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }} >
                                <div className="input-group-append">
                                    <span className="input-group-text">
                                        <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                    </span>
                                </div>
                            </button>
                        </div>
                        {showPreferenceButton && <div className="m-1" style={{ paddingTop: "12px" }}>
                            <PreferenceRoundButton
                                icon={"gear"}
                                title={lang.preference_button_tooltip}
                                onClick={() => { setShowPreferences(!showPreferences) }}
                            />
                        </div>}
                        <div className="mt-1" style={{ paddingTop: "12px" }}>
                            <RefreshButton
                                onClick={refreshCollection}
                            />
                        </div>
                        {!hideArchive && <div className="d-inline mt-3 mr-2">
                            <input type='checkbox' name='FilteredArchive' checked={showArchived} onClick={onArchiveClick} onChange={() => { }} />  {lang.archive}
                        </div>}
                    </div>
                </div>
                {isLoading && <Loader />}

                {isNoRecords && <div style={{ margin: "0px 500px" }}><h4><strong>{lang.no_records_found}</strong></h4></div>}
                {!isLoading && !isNoRecords &&
                    <Grid
                        style={props.gridstyle ?? {
                            height: "76vh",
                        }}
                        ref={gridRef}
                        sort={gridSort}
                        sortable={sortable}
                        onSortChange={onSortChange}
                        rowRender={gridRowRender}
                        filterable={filterable}
                        skip={page.skip}
                        take={page.take}
                        onPageChange={pageChange}
                        total={total}
                        resizable={true}
                        onColumnResize={handleColumnResize}
                        data={
                            gridData.map((item) => ({
                                ...item,
                                [SELECTED_FIELD]: selectedState[idGetter(item)],
                            }))}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: enableMutliSelect,
                            drag: false,
                            cell: false,
                            mode: "multiple",
                        }}
                        pageable={{
                            pageSizes: PAGE_SIZES,
                            buttonCount: 10,
                            info: true,
                            type: "numeric",
                            previousNext: true
                        }}
                        dataItemKey={DATA_ITEM_KEY}
                        onSelectionChange={onSelectionChange}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                    >

                        {/* Edit Row */}
                        {showCommandCell && (
                            <GridColumn cell={MyCommandCell} width={"60px"} locked={true} resizable={false} />
                        )}

                        {/* Multi Select Checkbox row */}
                        {enableMutliSelect && (<GridColumn
                            field={SELECTED_FIELD}
                            width="50px"
                            headerSelectionValue={
                                gridData.findIndex(
                                    (item) => !selectedState[idGetter(item)]
                                ) === -1
                            }
                            locked={true}
                            filterable={false}
                        />
                        )}

                        {/* Rows Loop */}
                        {dataColumns.map((column, index) => {
                            if (column.type === COLUMNSTYPE.date) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateOnlyCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.custom) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={CustomCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.datetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TimeCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.name === "SID") {
                                return;
                            } else if (column.type === COLUMNSTYPE.image) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={(p) => ImageCell({ ...p, title: column.label })}
                                        title={column.label}
                                        width={column.width ?? 100}
                                        sortable={false}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.select) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyDatalookupCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.toggle) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyCustomToggleButton}
                                        title={column.label}
                                        width={85}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.checkbox) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={CheckboxCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.array) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ArrayCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.href) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={HrefCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.hyperlink) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={HyperLinkCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.enum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={EnumCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"}
                                        sortable={true}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.platform) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={PlatformCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.status) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={Mystatuscell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.localdatetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={LocalDateTimeColumn}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.icon) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={IconCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.arrayenum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={arrayEnumCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.color) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={colorCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.day) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={daysCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.multiLangCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyMultiLangArrayCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.textWithIcon) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TextWithIconCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.imageArrayCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ContentArrayImageCell}
                                        title={column.label}
                                        width={column.width ?? 350}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.castType) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={castTypeCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.SIDEnum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={(props) => SIDEnumCell({ ...props, fk_entityName: column.fk_entityName, fk_field: column.fk_field })}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.boolean) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyCheckBoxCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.transmissionTypeStatus) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TransmissionTypeStatusCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.mamStatus) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MAMStatusCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else {
                                return (
                                    column.type !== COLUMNSTYPE.hidden && (
                                        <GridColumn
                                            key={index}
                                            field={column.name}
                                            title={column.label}
                                            width={column.width ?? 200}
                                            sortable={true}
                                        />
                                    )
                                );
                            }
                        })}
                    </Grid>}
            </div>

            {openForm && (
                <CustomEditForm
                    {...props}
                    cancelEdit={handleCancelEdit}
                    onSubmit={handleSubmit}
                    refresh={refreshCollection}
                    item={editItem}
                    dataColumns={dataColumns}
                />
            )}
            {showPreferences && <UserPreference entityName={preferenceColumnENntityName} preferenceColumnENntityName={preferenceColumnENntityName} handleClose={onCloseUserPrefence} />}
            {showTransmissionBrowser &&
                <BossDialog
                    title={lang.transmission_browser_header}
                    onClose={() => setShowTransmissionBrowser(false)}
                    width="70vw"
                >
                    <TransmissionBrowser gridStyle={{ height: 'calc(100vh - 370px)' }} isFromMain={true} query={['mediaEpisodeSegment._id', 'in', selectedItemsRef.current.map(x => x._id)]} />
                </BossDialog >
            }
            {showCreateTransmission && <CreateTransmissionForm onSubmit={onSaveCreateTransmission} onClose={() => setShowCreateTransmission(false)} width={"25vw"} item={selectedItemsRef.current[0]} />}
            {showSegmentExtensionPopup && <SegmentExtensionEditForm segmentId={selectedItemsRef.current[0]?._id} onCancel={() => setShowSegmentExtensionPopup(false)} />}

            {transmissionReport.show && <TransmissionReportForm onClose={() => setTransmissionReport({ show: false, message: '', items: [] })} transmissionReport={transmissionReport} />}
            {showCreateSeriesTransmission && <CreateSeriesTransmissionForm onClose={onCloseSeriesTransmissionForm} item={selectedItemsRef.current?.length > 0 ? selectedItemsRef.current[0] : {}} />}
        </>
    );
};